import { BASE_API_URL, ICRM_ZALO, INTEGRATION_ZALO_API_URL } from 'utils/constants';
import { downloadFilePostNew, get, post } from '../../utils/api';
import { DataResponse } from '../response';
import { CommonModel } from 'services/Main/common_services';

// ===================== ZNS Model =============================//
// Data OA info
export interface ZNSInfo {
  id: string;
  description: string;
  name: string;
  avatar: string;
  cover: string;
  oaId: string;
  actived: boolean;
  createdToken: string;
  expriedToken: string;
}
export interface ZNSTemplate {
  stt: number
  znsTemplateId: string
  znsTemplateName: string
  znsTask: string
  statusName: string
  previewUrl: string
}

export interface ZaloTask {
  znsTaskCode: string
  znsTaskName: string
}

export interface ZaloTemplate {
  znsTemplateId: string
  znsTemplateName: string
}

export interface ZnsTableResponse {
  stt: number
  znsTemplateDetailName: string
  type: string
  maxLength: number
  minLength: number
  require: boolean
  fieldName: string
  discription: string
}

export interface DetailZNSTemplate {
  znsTemplateId: string
  znsTemplateName: string
  statusName: string
  znsTaskCode: string
  znsTaskName: string
  znsTableResponses: ZnsTableResponse[]
}

export type DataTypeReportZNS = Partial<{
  stt: number;
  znsTemplateId: string;
  // Tên mẫu zns
  znsTemplateName: string;
  // tracking id
  trackingId: number;
  // tên khách hàng
  profileName: string;
  // mã code khách hàng
  profileCode: string;
  // sđt
  phone: string;
  // Trạng thái gửi tin
  isSend: string;
  sendFromTime: string;
  sendToTime: string;
  receiveTime: any;
  // trạng thái phản hồi
  statusResponse: string
  status: string;

  // Thời gian gửi tin
  sendTime: string;
  // Thời gian phản hồi
  submitTime: string;
  // Tracking id
  taskId: string;
  taskCode: string;
  // Id mẫu zns
  znsId: string;
  // Thời gian phản hồi
  dateTime: string;

  // Loại nghiệp vụ
  workFlowName: string,

  profileId: string;
  // điểm
  point: number;

  // thời gian phản hồi
  createTime: string

  mess: string,
  // tên liên hệ
  contactName: string



}>;

// Khai báo phương thức
export interface IZNSServices {
  // ZNS info
  oaInfo(): Promise<DataResponse<ZNSInfo>>;
  // Edit oa info
  editOAInfo(actived: boolean, oaId: string): Promise<DataResponse<ZNSInfo>>;
  // Search list zns
  listZNSTemplate(data: object): Promise<DataResponse<Array<ZNSTemplate>>>;
  // List dropdown ZaloTask
  listDropdownZaloTask(): Promise<DataResponse<Array<ZaloTask>>>;
  // List dropdown template
  listDropdownZaloTemplate(): Promise<DataResponse<Array<ZaloTemplate>>>;
  listDropdownNghiepVuTemplate(): Promise<DataResponse<Array<CommonModel>>>;
  listDropdownZnsTemplate(): Promise<DataResponse<Array<CommonModel>>>;
  // Sync ZNS
  syncZNS(data: object): Promise<DataResponse<void>>
  // Detail ZNS Template
  detailZNSTemplate(templateId: string): Promise<DataResponse<DetailZNSTemplate>>

  // List zns report
  reportSendZNS(data: object): Promise<DataResponse<Array<DataTypeReportZNS>>>;
  // Export zns report
  exportReportZNS(data: object): Promise<void>;

}

// Hàm khởi tạo các phương thức của ZNS service
export function createZNSServices(): IZNSServices {
  return {
    oaInfo: async () => {
      return (await get(INTEGRATION_ZALO_API_URL, `ZNS/OAInfo`)).data;
    },
    editOAInfo: async (actived, oaId) => (await get(
      INTEGRATION_ZALO_API_URL,
      `ZNSOfficialOA/EditZaloOAInfo?Actived=${actived}&OAId=${oaId}`
    )).data,
    listZNSTemplate: async (data) => {
      return (await post(INTEGRATION_ZALO_API_URL, `ZNSTemplate/list`, data)).data
    },
    listDropdownZaloTask: async () => {
      return (await get(INTEGRATION_ZALO_API_URL, `ZNSTemplate/list-Dropdown-ZaloTask`)).data;
    },
    listDropdownZaloTemplate: async () => {
      return (await get(INTEGRATION_ZALO_API_URL, `ZNSTemplate/list-Dropdown-template`)).data;
    },
    listDropdownZnsTemplate: async () => {
      return (await get(ICRM_ZALO, `ZNS/get-list-zns`)).data;
    },
    listDropdownNghiepVuTemplate: async () => {
      return (await get(BASE_API_URL, `Common/get-list-workflow-zns`)).data;
    },
    syncZNS: async (data) => {
      return (await post(INTEGRATION_ZALO_API_URL, `ZNSTemplate/Sync`, data)).data
    },
    detailZNSTemplate: async (templateId) => {
      return (await get(INTEGRATION_ZALO_API_URL, `ZNSTemplateDetail/list?ZNSTemplateId=${templateId}`)).data;
    },
    reportSendZNS: async (data) => {
      return (await post(BASE_API_URL, `Reports/report-sendZNS`, data)).data;
    },
    exportReportZNS: async (data) => {
      return await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-reportZNS`, data);
    },
  };
}
